/** Last 6 characters, uppercase — customer-facing style for support requests and orders (display only). */
export function supportDisplayRef(id: string | undefined | null): string {
  const raw = (id ?? '').toString().replace(/\s/g, '');
  if (raw.length >= 6) return raw.slice(-6).toUpperCase();
  return raw.toUpperCase() || '—';
}
